import React from 'react';

interface Props {
	size: number;
}

export const SupplyChainIcon: React.FC<Props> = props => (
	<svg
		aria-hidden='true'
		height={props.size}
		viewBox='0 0 24 24'
		width={props.size}
		xmlns='http://www.w3.org/2000/svg'
	>
		<title>supplyChain</title>
		<g>
			<path d='M14.61 23.74a.42.42 0 01-.42-.42V12.19H9.68V.68a.42.42 0 11.84 0v10.67H15v12a.42.42 0 01-.39.39z' />
			<path d='M11.54 22.55a.41.41 0 01-.42-.41l-.1-7H6a.42.42 0 010-.84h5.85l.12 7.8a.42.42 0 01-.42.43zM18.93 9H13V2.53a.42.42 0 01.42-.42.42.42 0 01.42.42v5.58h5.12a.42.42 0 01.42.42.42.42 0 01-.45.47zM18 16.1a.41.41 0 01-.42-.42v-4.11h5.5a.42.42 0 010 .84h-4.65v3.27a.42.42 0 01-.43.42zM7.13 8.41h-5.5a.42.42 0 110-.84h4.66V2.45a.42.42 0 01.84 0z' />
			<path d='M19.85 9.88a1.35 1.35 0 111.35-1.35 1.34 1.34 0 01-1.35 1.35zm0-1.85a.51.51 0 10.51.5.51.51 0 00-.51-.53zM18 18.19a1.34 1.34 0 111.34-1.34A1.34 1.34 0 0118 18.19zm0-1.84a.5.5 0 10.5.5.5.5 0 00-.5-.5zM5.07 16.35A1.35 1.35 0 116.41 15a1.35 1.35 0 01-1.34 1.35zm0-1.85a.5.5 0 00-.5.5.5.5 0 101 0 .5.5 0 00-.5-.5zM6.92 12.19a1.35 1.35 0 111.34-1.35 1.35 1.35 0 01-1.34 1.35zm0-1.85a.51.51 0 100 1 .51.51 0 000-1z' />
			<path d='M6 11.48H.91a.42.42 0 01-.42-.42.42.42 0 01.42-.42H6a.42.42 0 01.42.42.41.41 0 01-.42.42z' />
		</g>
	</svg>
);
